import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Button, Form, Spin } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { DATE_BACKEND_FORMAT, ROLES, TIME_FORMAT } from '../../constants';
import BreadCrumb from '../../modules/breadcrumbs';
import { selectAllCompanies } from '../../modules/companies/stores/slice';
import { doGetCompanies } from '../../modules/companies/stores/thunk';
import { selectAllLocations } from '../../modules/locations/stores/slice';
import { doGetLocations } from '../../modules/locations/stores/thunk';
import { doCreateOrder } from '../../modules/orders/store/thunk';
import DeliveryForm from '../Forms/Orders/DeliveryForm';
import OrderForm from '../Forms/Orders/OrderForm';
import PickupForm from '../Forms/Orders/PickupForm';
import FormTitleHeader from '../Header/FormTitleHeader';
import './Order.scss';
import { IsReturnForm } from '../Forms/Orders/IsReturnForm';
import usePageView from '../../hooks/usePageView';

const initValuesForm = {
  load: 1,
  pickupDuration: 2,
  deliveryDuration: 2,
};

const OrderPage = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const breadCrumbs = [{ text: 'ORDERS', url: '/orders' }, { text: 'CREATE NEW ORDER' }];
  const [form] = Form.useForm();

  const isAdmin = useSelector((state) => state.auth.user.isAdmin);
  const user = useSelector((state) => state.auth.user);
  const role = user.role;

  const isFetchingCompany = useSelector((state) => state.company.isFetching);
  const isFetchingOrder = useSelector((state) => state.order.isFetching);
  const action = useSelector((state) => state.order.action);
  const status = useSelector((state) => state.order.status);
  const locations = useSelector((state) => selectAllLocations(state));
  const companies = useSelector((state) => selectAllCompanies(state));
  const isFetchingLocation = useSelector((state) => state.location.isFetching);
  const isFetching = isFetchingCompany || isFetchingLocation || isFetchingOrder;
  const [labelIds, setLabelIds] = useState([]);
  const [types, setTypes] = useState([]);

  // Emit page view event
  usePageView(window.location.href);

  useEffect(() => {
    dispatch(doGetCompanies({ page: 1, take: 100000 }));
    dispatch(doGetLocations({ page: 1, take: 100000 }));
  }, []);

  useEffect(() => {
    if (action === 'create' && status === 'succeeded') {
      history.push('/orders');
    }
  }, [isFetching, action, status]);

  const onClickCreate = () => {
    form.submit();
  };
  const handleSubmit = (params) => {
    const location = locations.find((l) => l.id === params.locationId);
    const deliveryAddress = params.deliveryAddress;
    const deliveryTimeStart =
      params.dateRange?.length > 0 && params.dateRange[0] ? params.dateRange?.[0].format(TIME_FORMAT) : undefined;
    const deliveryTimeEnd =
      params.dateRange?.length > 1 && params.dateRange[1] ? params.dateRange?.[1].format(TIME_FORMAT) : undefined;
    const day = params.deliveryDate?.format('dddd') || undefined;
    // TODO rework this to order bundle
    // const colli = params.colli.map((collo) => ({
    //   ...collo,
    //   length: collo.length ? Number(collo.length) : null,
    //   width: collo.width ? Number(collo.width) : null,
    //   height: collo.height ? Number(collo.height) : null,
    //   weight: collo.height ? Number(collo.weight) : null,
    // }));
    const data = {
      name: params.name,
      createdBy: params.createdBy,
      description: params.description,
      sizeWidth: params.sizeWidth ? params.sizeWidth + ' mm' : null,
      sizeLength: params.sizeLength ? params.sizeLength + ' mm' : null,
      sizeHeight: params.sizeHeight ? params.sizeHeight + ' mm' : null,
      weight: params.weight ? params.weight + ' g' : null,
      orderRef: params.orderRef,
      locationId: location.locationId,
      status: params.status || undefined,
      deliveryDate: params.deliveryDate?.format(DATE_BACKEND_FORMAT) || undefined,
      isReturn: params.isReturn,
      pickupName: isReturn ? params.pickupName : location.name,
      pickupAddress: isReturn ? params.pickupAddress.addressObject : null,
      pickupAddressLat: isReturn ? params.pickupAddress?.addressLat?.toString() : String(location?.addressLat),
      pickupAddressLng: isReturn ? params.pickupAddress?.addressLng?.toString() : String(location?.addressLng),
      pickupPhone: params.pickupPhone,
      pickupNote: params.pickupNote,
      pickupDuration: params.pickupDuration ? Number(params.pickupDuration) : undefined,
      pickupTimeStart: location?.[day?.toLowerCase() + 'From'],
      pickupTimeEnd: location?.[day?.toLowerCase() + 'To'],
      deliveryName: isReturn ? location.name : params.deliveryName,
      deliveryEmail: isReturn ? params.pickupEmail : params.deliveryEmail,
      deliveryAddress: isReturn ? null : deliveryAddress.addressObject,
      deliveryAddressLat: isReturn
        ? String(location?.addressLat)
        : deliveryAddress?.latLng?.lat
          ? String(deliveryAddress?.latLng?.lat)
          : null,
      deliveryAddressLng: isReturn
        ? String(location?.addressLng)
        : deliveryAddress?.latLng?.lng
          ? String(deliveryAddress?.latLng?.lng)
          : null,
      deliveryPhone: isReturn ? params.pickupPhone : params.deliveryPhone,
      deliveryTimeStart: deliveryTimeStart,
      deliveryTimeEnd: deliveryTimeEnd,
      deliveryNote: params.deliveryNote,
      deliveryDuration: params.deliveryDuration ? Number(params.deliveryDuration) : undefined,
      load: params.load ? Number(params.load) : undefined,
      types: types,
      labelIds: labelIds,
      location: params.location,
      supportNote: params?.supportNote,

      // colli: colli,
    };
    dispatch(doCreateOrder(data));
  };

  const onValuesChange = (changedValues, allValues) => {
    const keysUpdate = Object.keys(changedValues);
    if (keysUpdate.includes('deliveryDate') || keysUpdate.includes('locationId')) {
      const location = locations.find((l) => l.id === allValues.locationId);
      if ((allValues.locationId || allValues.deliveryDate) && location) {
        if (allValues.deliveryDate && location) {
          const day = allValues.deliveryDate?.format('dddd');
          form.setFieldValue(
            'pickupTimeWindow',
            `${location[day.toLowerCase() + 'From'] || ''} - ${location[day.toLowerCase() + 'To'] || ''}`,
          );
        } else {
          form.setFieldValue('pickupTimeWindow', undefined);
        }

        if (isReturn) {
          form.setFieldValue('deliveryAddress', location.address);
          form.setFieldValue('deliveryPhone', location.phone);
        } else {
          form.setFieldValue('pickupAddress', location.address);
          form.setFieldValue('pickupPhone', location.phone);
        }
      } else {
        form.setFieldValue('pickupTimeWindow', undefined);
        form.setFieldValue('pickupAddress', undefined);
        form.setFieldValue('pickupPhone', undefined);
      }
    }
  };
  const [isReturn, setIsReturn] = useState(form.getFieldValue('isReturn'));

  return (
    <Spin spinning={isFetching}>
      <div className="Content OrderPage">
        <BreadCrumb breadCrumbs={breadCrumbs} />
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            initialValues={initValuesForm}
            onFinish={handleSubmit}
            onValuesChange={onValuesChange}
          >
            <FormTitleHeader title="Order Info" />

            <OrderForm form={form} labelIds={labelIds} setLabelIds={setLabelIds} types={types} setTypes={setTypes} />
            <>
              <FormTitleHeader
                title={
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>Colli</div>
                    </div>
                  </>
                }
              />
              {/* TODO: fix this */}
              {/* <Form.List name="colli" initialValue={[{}]}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div key={key} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 9 }}>
                          <ColloForm {...restField} name={name} isNew={true} />
                        </div>
                        <div style={{ flex: 1 }}>
                          {fields.length > 1 && (
                            <Button type="link" className="edit" onClick={() => remove(name)}>
                              <ReactSVG className="icon" src="/icons/delete.svg" />
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                      <Button
                        type="default"
                        className="CreateButton ButtonWhite"
                        onClick={() => add()}
                        style={{ marginRight: '24px' }}
                      >
                        Add Collo&nbsp;&nbsp; <ReactSVG src="/icons/plus.svg" />
                      </Button>
                    </div>
                  </>
                )}
              </Form.List> */}
            </>
            {(isAdmin || role === ROLES.ADMIN) && (
              <>
                <FormTitleHeader title="Order is return" />
                <IsReturnForm onChange={setIsReturn} />
              </>
            )}

            {isReturn ? (
              <>
                <FormTitleHeader title="Pickup" />
                <DeliveryForm form={form} isReturn />
                <FormTitleHeader title="Delivery" />
                <PickupForm locations={locations} companies={companies} form={form} isReturn />
              </>
            ) : (
              <>
                <FormTitleHeader title="Pickup" />
                <PickupForm locations={locations} companies={companies} form={form} />
                <FormTitleHeader title="Delivery" />
                <DeliveryForm form={form} />
              </>
            )}

            <div className="FormFooter">
              <Link to="/orders">
                <Button className="ButtonCancel">Cancel</Button>
              </Link>
              <Button className="CreateButton ButtonPrimary" type="primary" onClick={onClickCreate}>
                Create
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Spin>
  );
};

export default OrderPage;
